// removed by extract-text-webpack-plugin
module.exports = {"colorPrimary":"#EF473F"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/element-variables.scss
// module id = +hAf
// module chunks = 11